import { ArrowBackIosNew } from '@mui/icons-material';
import { IconButton, Stack, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const Container = styled('div')(({ theme }) => ({
  borderBottom: `1px solid ${theme.borderColors.default}`,
  padding: theme.spacing(0.5),
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const MobileMenuHeader = () => {
  const { t } = useTranslation();
  const location = useLocation();

  if (location.pathname === '/') return null;

  return (
    <Container>
      <IconButton component={RouterLink} disableRipple to="/">
        <Stack alignItems="center" direction="row" gap={1}>
          <ArrowBackIosNew sx={{ color: 'secondary.main', width: '1rem' }} />
          <Typography component="h3" sx={{ color: 'text.primary' }} fontWeight="bold">
            {t('backToMenu')}
          </Typography>
        </Stack>
      </IconButton>
    </Container>
  );
};
